import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Bot, Webhook, Code, AlertCircle } from 'lucide-react';

export default function FAQ() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-700 to-blue-500 py-8 px-4">
      <div className="max-w-4xl mx-auto bg-black/40 backdrop-blur-md shadow-xl rounded-lg p-8 border border-blue-500/20">
        <Link
          to="/"
          className="inline-flex items-center text-cyan-300 hover:text-cyan-200 transition-colors mb-8 group"
        >
          <ArrowLeft className="h-5 w-5 mr-2 transition-transform group-hover:-translate-x-1" />
          Back to Home
        </Link>

        <h1 className="text-4xl font-bold text-white mb-8 bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
          Frequently Asked Questions
        </h1>
        
        <div className="space-y-8">
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">
              General Questions
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-medium text-white mb-2">What is AIX?</h3>
                <p className="text-gray-300">
                  AIX is an advanced AI-powered trading bot platform designed for club members to share, learn, and explore algorithmic trading strategies.
                </p>
              </div>
              <div>
                <h3 className="text-xl font-medium text-white mb-2">How do I get started?</h3>
                <p className="text-gray-300">
                  To get started, simply create an account and log in. You'll have access to our trading bots and can begin exploring different strategies.
                </p>
              </div>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">
              TradingView Integration
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-medium text-white mb-2">How do I set up TradingView alerts?</h3>
                <div className="space-y-4 text-gray-300">
                  <div className="bg-black/20 rounded-lg p-4">
                    <h4 className="text-lg font-medium text-white mb-2">Alert Message Format</h4>
                    <pre className="text-sm text-gray-300 bg-black/30 p-3 rounded-md overflow-x-auto">
                      exchange=&#123;&#123;exchange&#125;&#125;, ticker=&#123;&#123;ticker&#125;&#125;, price=&#123;&#123;close&#125;&#125;, &#123;&#123;message&#125;&#125;
                    </pre>
                    <p className="mt-2 text-sm">Example:</p>
                    <pre className="text-sm text-gray-300 bg-black/30 p-3 rounded-md overflow-x-auto">
                      exchange=binance, ticker=BTCUSDT, price=45000, Buy signal triggered
                    </pre>
                  </div>

                  <div>
                    <h4 className="text-lg font-medium text-white mb-2">Alert Setup Steps</h4>
                    <ol className="list-decimal list-inside space-y-2">
                      <li>Set alert condition in TradingView (e.g., RSI crosses 70)</li>
                      <li>Choose "Webhook URL" as the alert action</li>
                      <li>Paste your bot's webhook URL</li>
                      <li>Use the message format shown above</li>
                      <li>Set alert to "Once Per Bar Close" for best results</li>
                    </ol>
                  </div>

                  <div>
                    <h4 className="text-lg font-medium text-white mb-2">Supported Signal Parameters</h4>
                    <ul className="list-disc list-inside space-y-2">
                      <li>Include "Buy" or "Sell" in the message for trade signals</li>
                      <li>Add position size in USDT (e.g., "size=1000")</li>
                      <li>Optional: Add stop loss/take profit levels</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-white border-b border-blue-500/30 pb-2">
              Support
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-medium text-white mb-2">How can I get help?</h3>
                <p className="text-gray-300">
                  For support, you can reach out to us through our <a href="https://t.me/teamiccc" target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-cyan-300">Telegram channel</a>. Our team is always ready to assist you.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
